import React from 'react';
import { TextField, FlatButton } from 'material-ui';

const UpdateLocationName = props => {
  const {
    data: { newLocationName },
    onTextFieldChangeWithKeyPath,
    onRequestClose,
    saveSupplierInfoChanges,
    locationId,
    contractId,
  } = props;
  const onSave = () => saveSupplierInfoChanges({
    contractId,
    data: { newLocationName },
    updateType: 'SAVE_LOCATION_NAME',
  });
  return (
    <div style={{ width: '95%', margin: 'auto' }}>
      <TextField
        id="locName"
        value={newLocationName}
        onChange={e => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'newLocationName'], value: e.target.value })}
      />
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <div className="flex-center">
          <FlatButton
            label="Cancel"
            primary
            onClick={onRequestClose}
          />
          <FlatButton
            label="Save"
            secondary
            onClick={onSave}
          />
        </div>
      </div>
    </div>
  );
};

export default UpdateLocationName;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/update-location-name.jsx